import type { PermissionTypeEnum } from '~/services/MSAPI/user/types'

export const usePermissionUtils = () => {
  const authStore = useAuthStore()

  const userPermissions = computed(() => authStore.userData.permissions)

  const hasSessionPermission = (
    permissionType: PermissionTypeEnum,
  ): boolean => {
    return (
      userPermissions.value?.some(
        (userPermission) => userPermission.type === permissionType,
      ) ?? false
    )
  }

  return { hasSessionPermission }
}
